export default "__VITE_PUBLIC_ASSET__434fbb51__"